import service from '@/utils/axios';

//栏目分类列表
export function getNavList() {
    return service({
        url: '/admin/api/v1/dxsf/official/getHeadCoiumn',
    })
}


// WEBPACK FOOTER //
// ./src/api/topNav.js